import axios from 'axios'
import { BASE_URL, JWT_APP_ID } from '../../config/URL'

export const getPackageGroups = (ids) => async (_dispatch, getState) => {
  const pathParams = ids.map(id => `ids[]=${id}`).join('&')
  const state = getState()
  const res = await axios.get(`${BASE_URL}/subscription/v1.1/packageGroups?${pathParams}`, {
    headers: {
      Authorization: state.auth.token
    }
  })

  return res.data
}

export const getMedia = (id) => async () => {
  const res = await axios.get(`${BASE_URL}/catalog/v1.1/packageGroup/${id}/items?locale=en&page=1&perPage=25`, {
    headers: {
      'Cloudfront-JWT-AppId': JWT_APP_ID
    }
  })

  return res.data
}

export const getPackages = () => async (dispatch, getState) => {
  const state = getState()
  dispatch({
    type: 'GET_PACKAGES'
  })
  const res = await axios.get(`${BASE_URL}/subscription/v1.1/packages`, {
    headers: {
      Authorization: state.auth.token,
      'Cloudfront-JWT-AppId': JWT_APP_ID
    }
  })

  dispatch({
    type: 'GET_PACKAGES_SUCCESS',
    payload: res.data.data
  })
}

export const getPaymentGatewayPackages = () => async (dispatch, getState) => {
  const state = getState()
  const memberId = state.auth.user && state.auth.user.account.id
  dispatch({
    type: 'GET_PAYMENT_GATEWAY_PACKAGES'
  })
  try {
    const res = await axios.get(`${BASE_URL}/subscription/v1.1/paymentGateways/getSubscriberPlan?accountId=${memberId}`, {
      headers: {
        Authorization: state.auth.token,
        'Cloudfront-JWT-AppId': JWT_APP_ID
      }
    })
    dispatch({
      type: 'GET_PAYMENT_GATEWAY_PACKAGES_SUCCESS',
      payload: res.data.data
    })
  } catch (err) {
    console.log(err)
    dispatch({
      type: 'GET_PAYMENT_GATEWAY_PACKAGES_ERROR',
      err
    })
  }
}